import React from 'react';

const EmdashText = () => (
    <span>—</span>
);

export default EmdashText;